import { trackBigBrainEventOnServer } from "/server/services/bigbrain-tracking-service/bigbrain-tracking-service";
import { SOLUTION_PAGE_WITH_INVALID_SOLUTION_ERROR, SOLUTION_PAGE_ERROR } from "constants/bigbrain-event-types";
import Error from "next/error";
import {
  SINGLE_SOLUTION_PAGE_TYPE,
  SOLUTIONS_IN_CATEGORY_PAGE_TYPE,
  SOLUTIONS_HOME_PAGE_TYPE,
  SOLUTIONS_SEARCH_PAGE_TYPE
} from "constants/template-center/solution-page-types";
import SolutionPageLayoutComponent from "components/pages/solutions/solution-page-layout-component";

import { solutionExists, categoryExists, filterCategories } from "template-store/services/solutions-service";
import BaseTemplatePage from "../../generated-templates/base-template-page";

export default class SolutionPage extends BaseTemplatePage {
  static validate = (allSolutions, allCategories, pageType, { solutionId, categoryId }) => {
    switch (pageType) {
      case SINGLE_SOLUTION_PAGE_TYPE: {
        return !!solutionId && solutionExists(allSolutions, solutionId);
      }
      case SOLUTIONS_IN_CATEGORY_PAGE_TYPE: {
        return !!categoryId && categoryExists(allCategories, categoryId);
      }
      case SOLUTIONS_SEARCH_PAGE_TYPE:
      case SOLUTIONS_HOME_PAGE_TYPE: {
        return true;
      }
      default: {
        return false; // must come with a page type
      }
    }
  };

  static async getInitialProps({ req, res, asPath, query }) {
    const superInitialProps = await BaseTemplatePage.getInitialProps({ req, res, asPath });

    const { solutionId, categoryId } = req.params;
    const { term } = req.query;
    const { pageType } = query;

    res.statusCode = 200;
    try {
      const { getMondaySolutionData } = require("/server/services/solutions/solutions-api-service");
      const { localeToUse } = superInitialProps;
      const solutionData = await getMondaySolutionData(localeToUse);
      const allSolutions = solutionData.solutions;
      const allCategories = filterCategories(solutionData.categories, allSolutions);

      const tabsMetadata = {
        integrations: solutionData.integrations,
        columns: solutionData.columns,
        views: solutionData.views
      };

      const isValid = this.validate(allSolutions, allCategories, pageType, { solutionId, categoryId });

      if (!isValid) {
        await trackBigBrainEventOnServer(SOLUTION_PAGE_ERROR, {
          placement: req.url,
          info2: req.params,
          directObject: req.hostname
        });
        res.statusCode = 404;
      }

      return {
        ...superInitialProps,
        allSolutions,
        allCategories,
        pageType,
        searchTermFromAdressBar: term,
        solutionId,
        categoryId,
        tabsMetadata,
        asPath,
        statusCode: res.statusCode
      };
    } catch (e) {
      await trackBigBrainEventOnServer(SOLUTION_PAGE_WITH_INVALID_SOLUTION_ERROR, {
        placement: req.url,
        info1: e.message,
        info2: req.params,
        directObject: req.hostname
      });
      console.log(e.message);
      res.statusCode = 500;
      return {
        statusCode: res.statusCode
      };
    }
  }

  render() {
    const { statusCode, ...restProps } = this.props;
    if (statusCode !== 200) return <Error statusCode={statusCode} />;
    return <SolutionPageLayoutComponent {...restProps} />;
  }
}
